import { Box, Container, Grid, Typography } from "@mui/material";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { appIcons, appImages } from "../../assets";
import GlobalButton from "../../components/button";
import AppFooter from "../../components/footer";
import NavBar from "../../components/NavBar/index.js";
import PaymentMethodDialog from "../../components/payMethodDialog.js";
import Billing from "./Billing.js";
import ShippingInfo from "./ShippingInfo.js";
import { t } from "i18next";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_API_KEY);
// const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_TEST_API_KEY);

const ProductCheckout = () => {
  const openPayDialog = useRef();
  const navigate = useNavigate();
  const [isAcceptPolicy, setisAcceptPolicy] = useState(true);
  const cartData = useSelector((state) => state.cartReducer.cartData);

  const [searchParams] = useSearchParams();
  const packageId = searchParams.get("package");

  useEffect(() => {
    if (!packageId && cartData?.length === 0) {
      navigate(-1);
    }
  }, []);

  return (
    <>
      <NavBar />
      <Box
        height={{ xs: "60vh", sm: "100vh" }}
        display="flex"
        flexDirection="column"
        position={"relative"}
        sx={{
          //   background: palette.gradient.background,
          backgroundImage: `url(${appImages.pdDetailBgImg})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        {/* <Header /> */}
      </Box>

      <Box position={"absolute"} top={{ xs: 120, sm: 160 }} left={0} right={0}>
        <Container
          sx={{
            maxWidth: "1100px !important",
            position: "relative",
            zIndex: 999,
          }}
        >
          <GlobalButton
            handleClickBtn={() => navigate(-1)}
            variant={"outlined"}
            btnText={"goBack"}
            startIcon={<img src={appIcons.whiteArrowBackIcon} width={30} />}
            styleProps={{
              color: "text.white",
              borderColor: "text.white",
            }}
          />

          <Typography
            variant="heading_sec"
            component={"h1"}
            textAlign={"center"}
            color={"text.white"}
            lineHeight={"normal"}
            mb={1}
          >
            {t("productCheckout")}
          </Typography>
          <Typography
            variant="heading_pr"
            component={"h1"}
            maxWidth={700}
            margin={"auto"}
            textAlign={"center"}
            color={"text.white"}
            lineHeight={"normal"}
            textTransform={"capitalize"}
            mb={5}
          >
            {t("checkout")}
          </Typography>

          <Container
            sx={{
              px: 1,
              py: 3,
              bgcolor: "white",
              boxShadow: "rgba(0, 0, 0, 0.09) 0px 3px 12px",
              borderWidth: 1,
              borderColor: "text.coolGrey",
              borderRadius: 1,
            }}
          >
            <Grid container rowSpacing={1} columnSpacing={5}>
              <Grid item xs={12} md={6}>
                <ShippingInfo
                  isAcceptPolicy={isAcceptPolicy}
                  setisAcceptPolicy={setisAcceptPolicy}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Elements stripe={stripePromise}>
                  <Billing isAcceptPolicy={isAcceptPolicy} />
                </Elements>
              </Grid>
            </Grid>
          </Container>
        </Container>
        <AppFooter bgcolor={true} />
        <PaymentMethodDialog
          ref={openPayDialog}
          handleConfirm={() => navigate("/")}
        />
      </Box>
    </>
  );
};

export default ProductCheckout;
